import { render, staticRenderFns } from "./unionLogin.vue?vue&type=template&id=38fa4237&scoped=true&"
import script from "./unionLogin.vue?vue&type=script&lang=js&"
export * from "./unionLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fa4237",
  null
  
)

export default component.exports